// src/pages/Messages.js
import React from 'react';

const Messages = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">Messages</h2>
      <p>This is the Messages page. You’ll see your project conversations here.</p>
    </div>
  );
};

export default Messages;